
import {
  Component, Prop, Vue, Inject,
} from 'nuxt-property-decorator'
import BaseGridLayout from './layouts/BaseGridLayout.vue'

@Component({
  name: 'SeparationLineAnchor',
  components: {
    BaseGridLayout,
    SeparationLine: () => import('./SeparationLine.vue'),
    BaseHeadline: () => import('./base/BaseHeadline.vue'),
  },
})
export default class SeparationLineAnchor extends Vue {
  @Prop({ default: '' }) headline! : string

  @Prop({ default: '' }) anchorText! : string

  @Prop({ default: true }) showSeparationLine! : boolean

  @Inject({ from: 'separationLineUsedInContentProjection', default: false }) usedInArticle! : boolean
}
